import { defineComponent as _defineComponent } from 'vue'
import {banksDictionary} from '@/commons/dictionaries/BanksDictionary';
import {
  AllUserInputPanels,
  UserInputPanelElementEnum
} from '@/components/calculator/results/userInputPanel/UserInputPanelElementEnum';
import {cloneDeep} from 'lodash-es';
import {computed, Ref, ref} from 'vue';
import ResultSimpleUserInputForm from '@/components/calculator/results/userInputPanel/ResultSimpleUserInputForm.vue';
import CalculatorSummary from '@/components/calculator/results/CalculatorSummary.vue';
import FpChipRadio from '@/components/inputs/FpChipRadio.vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import useOfferSorting, {
  FilterCategory,
  OfferFilters
} from '@/components/calculator/results/OfferSorting';
import SimulationToolbarSort from '@/components/calculator/results/toolbar/SimulationToolbarSort.vue';
import SimulationToolbarZoom from '@/components/calculator/results/toolbar/SimulationToolbarZoom.vue';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {BankSymbol} from '@/commons/dictionaries/BankSymbol';
import {Offer} from '@/models/simulation/Simulation';
import {BankDictionaryElement} from '@/modules/banks/models/BankDictionaryElement';
import OfferFilterCheckbox from '@/components/calculator/results/userInputPanel/OfferFilterCheckbox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInputPanel',
  setup(__props) {

const userInputPanelElementEnum: typeof UserInputPanelElementEnum = UserInputPanelElementEnum;
const allUserInputPanels: UserInputPanelElementEnum[] = AllUserInputPanels;
const store = useSimulationStore();
const {
  insuranceItems,
  extraProductItems,
  getVisibleFiltersByCategory,
} = useOfferSorting();

const userPanels: Ref<UserInputPanelElementEnum[]> = ref(cloneDeep(AllUserInputPanels));
const onFormChange = store.debouncedUpdateSimulation();
const panelsModel = computed({
  get: () => userPanels.value.map((x) => allUserInputPanels.indexOf(x)),
  set: (newPanelsArray) => {
    userPanels.value = allUserInputPanels.filter((x, index) => newPanelsArray.includes(index));
  },
});
const banks = computed(() => {
  const offers: Offer[] = store.isShownAvailableProducts
    ? store.filteredOffers : store.simulation?.refusedOffers ?? [];
  return banksDictionary()
    .filter(x => x.products![store.productType!])
    .map((x: BankDictionaryElement) => ({
      type: x.type,
      name: x.name_pl,
      count: offers.filter(offer => offer.info.bank === x.type).length,
    }));
}
);

const isSomeFilterSelected = computed<boolean>(
  () => !!store.userInput?.offerFilters && Object.values(store.userInput.offerFilters).some(x => x)
);

const selectedBanks = computed<BankSymbol[]>({
  get: () =>
    store.isShownAvailableProducts ? store.userInput!.selectedBanks : store.userInput!.refusedOffers.selectedBanks,
  set: (selectedBanks: BankSymbol[]) => {
    if (store.isShownAvailableProducts) {
          store.userInput!.selectedBanks = selectedBanks;
    } else {
          store.userInput!.refusedOffers.selectedBanks = selectedBanks;
    }
  },
});

const offerFeatureFilters = computed<OfferFilters[]>(
  () => getVisibleFiltersByCategory(FilterCategory.OFFER_FEATURES)
);

const programOffersFilters = computed<OfferFilters[]>(
  () => getVisibleFiltersByCategory(FilterCategory.PROGRAM)
)

const referenceRateFilters = computed<OfferFilters[]>(
  () => getVisibleFiltersByCategory(FilterCategory.REFERENCE_RATE)
)

const interestRateFilters = computed<OfferFilters[]>(
  () => getVisibleFiltersByCategory(FilterCategory.INTEREST_RATE)
);

return { __sfc: true,userInputPanelElementEnum, allUserInputPanels, store, insuranceItems, extraProductItems, getVisibleFiltersByCategory, userPanels, onFormChange, panelsModel, banks, isSomeFilterSelected, selectedBanks, offerFeatureFilters, programOffersFilters, referenceRateFilters, interestRateFilters, ResultSimpleUserInputForm, CalculatorSummary, FpChipRadio, SimulationToolbarSort, SimulationToolbarZoom, I18NGetter, OfferFilterCheckbox }
}

})